module.exports = __webpack_public_path__ + "0391e8b565617fde8e7228e5689748a3.svg";